const NotificationMsg = ({
  children
}) => {
  return <div className="notification">
        <div className="notification--icon">
          <i className="foundry-icon icon--info icon--gray" />
        </div>
        <div className="notification--msg">
          {children}
        </div>
      </div>;
};
export const Notification = ({
  withWrapper,
  ...props
}) => {
  if (withWrapper) {
    return <div className="notification--wrapper">
        <NotificationMsg {...props} />
      </div>;
  }
  return <NotificationMsg {...props} />;
};